<script lang="ts">
    import ReviewGridIcon from "@apps/reviews/components/icons/ReviewGridIcon.svelte";
    import ReviewListViewIcon from "@apps/reviews/components/icons/ReviewListViewIcon.svelte";
    import { REVIEWS_WIDGET_LAYOUT } from "@apps/reviews/constants";
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import ButtonWithIcon from "@components/Buttons/ButtonWithIcon.svelte";
    import Icon from "@components/Icon.svelte";

    export let layout: REVIEWS_WIDGET_LAYOUT;

    const dispatch = createEventDispatcher();

    const handleClickGrid = () => {
        dispatch("changeLayout", {
            value: REVIEWS_WIDGET_LAYOUT.GRID_LAYOUT,
        });
    };

    const handleClickListing = () => {
        dispatch("changeLayout", {
            value: REVIEWS_WIDGET_LAYOUT.LISTING_LAYOUT,
        });
    };
</script>

<div class="gw-rv-layout-view">
    <ButtonWithIcon
        class={CN("gw-rv-layout-view__button", {
            "gw-rv-layout-view__button-active":
                layout === REVIEWS_WIDGET_LAYOUT.GRID_LAYOUT,
        })}
        big
        on:click={handleClickGrid}
        ariaLabel="Change to masonry layout"
    >
        <Icon width="20" height="20">
            <ReviewGridIcon />
        </Icon>
    </ButtonWithIcon>
    <div class="gw-rv-layout-view__divider" />
    <ButtonWithIcon
        class={CN("gw-rv-layout-view__button", {
            "gw-rv-layout-view__button-active":
                layout === REVIEWS_WIDGET_LAYOUT.LISTING_LAYOUT,
        })}
        big
        on:click={handleClickListing}
        ariaLabel="Change to listing layout"
    >
        <Icon width="20" height="20">
            <ReviewListViewIcon />
        </Icon>
    </ButtonWithIcon>
</div>

<style lang="postcss">
    :global(.gw-btn.gw-btn-with-icon.gw-rv-layout-view__button) {
        width: auto;
        height: 100%;
        padding: 0.625em;
        border-radius: 0.625em;

        &:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        &:last-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
        }
    }

    :global(.gw-btn.gw-rv-layout-view__button-active) {
        background-color: rgba(38, 40, 66, 0.08);
    }

    .gw-rv-layout-view {
        display: flex;
        align-items: center;
        height: 2.5em;
        border: 1px solid rgba(38, 40, 66, 0.12);
        border-radius: 10px;

        &__divider {
            width: 1px;
            height: 100%;
            background: rgba(38, 40, 66, 0.12);
        }
    }
</style>
